import {
  createTheme as createMuiTheme,
} from '@material-ui/core';

import type { Theme as MuiTheme } from '@material-ui/core/styles/createTheme';
import type { Shadows as MuiShadows } from '@material-ui/core/styles/shadows';
import type {
  Palette as MuiPalette,
  TypeBackground as MuiTypeBackground
} from '@material-ui/core/styles/createPalette';

import lightTheme from './light.theme';

import { defaultShadows } from './shadows';
import typography from './typography';

export { defaultShadows, typography };

const themesOptions: ThemeOptions[] = [
  lightTheme,
]

interface TypeBackground extends MuiTypeBackground {
  dark: string;
}

interface Palette extends MuiPalette {
  background: TypeBackground;
}

export interface Theme extends MuiTheme {
  name: string;
  palette: Palette;
}

type Direction = 'ltr' | 'rtl';

interface ThemeConfig {
  direction?: Direction;
  responsiveFontSizes?: boolean;
  theme?: string;
}

interface ThemeOptions { 
  name?: string;
  direction?: Direction;
  typography?: Record<string, any>;
  overrides?: Record<string, any>;
  palette?: Record<string, any>;
  shadows?: MuiShadows;
}


export const createTheme = (config: ThemeConfig = {}): Theme => {
  
  let themeOptions = themesOptions.find((theme) => theme.name === config.theme);

  if (!themeOptions) {
    console.warn(new Error(`Theme ${config.theme} is not valid`));
    [themeOptions] = themesOptions;
  }

  const theme = createMuiTheme(themeOptions);

  return theme as Theme;

}

